import { CompetitorTypes } from "~enums/competitorTypes";
import { ImageTypes } from "~enums/imageTypes";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { Image } from "~types/image";
import { findImageByType } from "~utilities/findImageByType";

type Props = {
  entrant: { nameFullLocal: string; images: Image[]; id: string };
  isHome?: boolean;
};

const Logo = ({ url }: { url: string }) => (
  <span style={{ marginLeft: 2, marginRight: 2 }}>
    {url ? <img alt="Logo" src={url} width={25} height={25} /> : <i style={{ width: 25 }} className="fas fa-shield fa-xl" />}
  </span>
);

const EntrantColumn = ({ entrant, isHome }: Props) => {
  const { competitorType } = useSportConfiguration();
  let logoUrl = "";
  if (competitorType === CompetitorTypes.Entity) {
    logoUrl = findImageByType(entrant?.images, ImageTypes.Logo) || findImageByType(entrant?.images, ImageTypes.LogoAlternate) || "";
  }
  if (competitorType === CompetitorTypes.Person) {
    logoUrl = findImageByType(entrant?.images, ImageTypes.PersonHead) || "";
  }

  return (
    <>
      {!isHome && <Logo url={logoUrl} />}
      <span>{entrant?.nameFullLocal}</span>
      {isHome && <Logo url={logoUrl} />}
    </>
  );
};

export default EntrantColumn;
